import { FormattedMessage } from 'react-intl'
import {
  LoginBannerContainer,
  LoginBannerIconContainer,
  LoginBannerLeftContent,
  LoginBannerSubTitle,
  LoginBannerTextContainer,
  LoginBannerTitle
} from '../../styled-components'

import {
  useBrowserInfo,
  useIsMobile
} from '../../../../zustand/browser-store/use-browser-store'
import { useState } from 'react'
import ButtonComponent from '../../../../components/stories/atoms/button/index.jsx'
import {
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions
} from '../../../../components/stories/atoms/button/constants.js'
import { Cancel } from '../../../../components/stories/atoms/icons/essentials/index.js'
import { iconSizeOptions } from '../../../../components/stories/atoms/icons/icons-sizes.js'
import { AppMobileIcon } from '../../../../components/stories/atoms/icons/versions/index.js'

const LoginStoreBanner = ({ show = true }) => {
  const [isOpen, setIsOpen] = useState(true)

  const handleToggleIsOpen = () => {
    setIsOpen((prev) => !prev)
  }
  const isMobile = useIsMobile()
  const browser = useBrowserInfo()

  if (!show) {
    return
  }

  return (
    <>
      {isMobile &&
        isOpen &&
        (browser.os === 'Android OS' || browser.os === 'iOS') && (
          <LoginBannerContainer>
            <ButtonComponent
              variant={buttonVariantOptions.GHOST}
              buttonType={buttonTypeOptions['ICON-ONLY']}
              onClick={handleToggleIsOpen}
              size={buttonSizeOptions.SMALL}
            >
              <Cancel />
            </ButtonComponent>

            <LoginBannerLeftContent>
              <LoginBannerIconContainer>
                <AppMobileIcon size={iconSizeOptions['ICON-L']} />
              </LoginBannerIconContainer>
              <LoginBannerTextContainer>
                <LoginBannerTitle>docu tools App</LoginBannerTitle>
                <LoginBannerSubTitle>
                  <FormattedMessage id="login_banner_download_app" />
                </LoginBannerSubTitle>
              </LoginBannerTextContainer>
            </LoginBannerLeftContent>

            <ButtonComponent
              variant={buttonVariantOptions['SECONDARY-HOLLOW']}
              size={buttonSizeOptions.SMALL}
              as="a"
              to={
                browser.os === 'Android OS'
                  ? 'https://play.google.com/store/apps/details?id=com.docutools.app'
                  : 'https://itunes.apple.com/at/app/docu-tools-3/id1316586033?mt=8'
              }
              target="_blank"
            >
              <FormattedMessage id="view" />
            </ButtonComponent>
          </LoginBannerContainer>
      )}
    </>
  )
}

export default LoginStoreBanner
